import type { ReactNode } from 'react';
import { Header } from './_shared';

export type Person = {
  name: string;
  role: string;
  photo?: string;
  bio?: string;
};

export type PeopleSlideProps = {
  eyebrow: ReactNode;
  title: ReactNode;
  people: ReadonlyArray<Person>;
  /** Grid column count. Defaults to people.length, clamped 2..4. */
  cols?: 2 | 3 | 4;
  /** Optional lead text column on the left (text+card layout). */
  lead?: ReactNode;
};

function clampPeopleCols(n: number): 2 | 3 | 4 {
  if (n <= 2) return 2;
  if (n === 3) return 3;
  return 4;
}

export function PeopleSlide({ eyebrow, title, people, cols, lead }: PeopleSlideProps) {
  const colCount = cols ?? clampPeopleCols(people.length);
  return (
    <div className="slide-body">
      <Header eyebrow={eyebrow} title={title} />
      <div className={`sn-work${lead ? ' sn-people--with-lead' : ''}`}>
        {lead && <div className="sn-people-lead">{lead}</div>}
        <div className={`sn-people-grid sn-people-grid--${lead ? 2 : colCount}`}>
          {people.map((p) => (
            <article key={p.name} className="sn-person">
              {p.photo && <img className="sn-person-photo" src={p.photo} alt={p.name} />}
              <h3 className="sn-person-name">{p.name}</h3>
              <span className="sn-person-role">{p.role}</span>
              {p.bio && <p className="sn-person-bio">{p.bio}</p>}
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
